import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'amountDollar' })
export class AmountDollarPipe implements PipeTransform {

    transform (value: any, _currency = null, _reverse = false) {

        if (value == null) {
            value = 0;
        }

        if ( typeof(_currency) === 'undefined' || _currency == null ) {
            _currency = '$';
        }

        if ( isNaN(value) ) {
            value = value.toString();
            value = value.replace(_currency, '');
            value = value.replace(',', '');
        }

        if ( _reverse ) {
            return value;
        }

        value = value.toString();
        if ( value.indexOf('.') === -1 ) {
            value = value + '.00';
        }
        return _currency + value.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/amount-dollar/amount-dollar.pipe.ts